<script>
  import service from '../../../../domain/leiloes/services'
  export default{
    name: 'select-categoria-leilao',
    props: {
      value: {required: true}
    },
    data () {
      return {
        categoriasLeilao: null,
        loadError: false
      }
    },
    computed: {
      model: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    },
    mounted () {
      this.load()
    },
    destroyed () {
    },
    methods: {
      load () {
        this.loadError = false
        service.buscaCategorias().then((response) => {
          this.categoriasLeilao = response.data.categorias.map(function (val) {
            return {label: val.nome, value: val.id, class: 'btn-default'}
          })
        })
          .catch((response) => {
            this.loadError = true
            console.log(response)
          })
      }
    },
    components: {}
  }
</script>

<template>
  <div>
    <u-button-group v-if="categoriasLeilao !== null" v-model="model" :options="categoriasLeilao"></u-button-group>
    <u-fake-loader width="320px" class="m-t" v-if="categoriasLeilao === null && !loadError"></u-fake-loader>
    <u-button class="btn btn-xs m-t-xs" v-if="loadError" @click="load()"><i class="icon icon-reload"></i> Erro ao carregar as categorias, tente novamente</u-button>
  </div>
</template>



// WEBPACK FOOTER //
// SelectCategoria.vue?00587d60